import { Badge } from "@chakra-ui/react"
import { FaBell, FaEye, FaCheck } from "react-icons/fa6"

export type AlertStatusType = "new" | "acknowledged" | "attended" | "completed"

interface AlertStatusBadgeProps {
  status: AlertStatusType
}

export const alertStatusConfig = {
  new: {
    label: "New",
    backgroundColor: "lifecycle.new.bg",
    textColor: "lifecycle.new.fg",
    icon: FaBell,
  },
  acknowledged: {
    label: "Acknowledged",
    backgroundColor: "lifecycle.acknowledged.bg",
    textColor: "lifecycle.acknowledged.fg",
    icon: FaEye,
  },
  attended: {
    label: "Attended",
    backgroundColor: "lifecycle.attended.bg",
    textColor: "lifecycle.attended.fg",
    icon: FaEye,
  },
  completed: {
    label: "Resolved",
    backgroundColor: "lifecycle.resolved.bg",
    textColor: "lifecycle.resolved.fg",
    icon: FaCheck,
  },
  ok: {
    label: "OK",
    backgroundColor: "lifecycle.resolved.bg",
    textColor: "lifecycle.resolved.fg",
    icon: FaCheck,
  }
}

export function AlertStatusBadge({ status }: AlertStatusBadgeProps) {
  const config = alertStatusConfig[status]
  const Icon = config.icon

  return (
    <Badge
      backgroundColor={config.backgroundColor}
      color={config.textColor}
      variant="subtle"
      display="inline-flex"
      alignItems="center"
      gap={1}
    >
      <Icon style={{ width: "12px", height: "12px" }} />
      {config.label}
    </Badge>
  )
}

export default AlertStatusBadge